import React, { Component } from "react";
import { connect } from "react-redux";
import Reaptcha from "reaptcha";

// Components
import GeneralLoader from "../../GeneralLoader";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import Button from "../../utils/Button";

// CSS
import "../../../css/forms/login.css";

// State
import { getReviewerLoginToken, reviewerLogin, clearErrors } from "../../../store/actions/user";

// Utils
import {
	handleKeyPress,
	handleInputChange,
	recaptchChanged
} from "../../../utils/forms/inputHandling";

class LoginForm extends Component {
	constructor(props) {
		super(props);
		this.captcha = null;
		this.state = {
			data: {
				email: "",
				password: "",
				recaptchaLoaded: false, // Has the reaptcha loaded
				showRecaptch: false // Should the recaptcha even try to load
			}
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	// ===================================
	//  LIFE CYCLE HOOKS
	// ===================================
	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);

		// When mounted, go check the API to see if user needs to show the recaptcha
		this.props.getReviewerLoginToken();
	}

	shouldComponentUpdate(nextProps) {
		// If the maxLoginsReached has changed, it means the user has attempted to login too many times and
		// we will have to show the recaptcha
		if (nextProps.maxLoginsReached && !this.state.showRecaptch) {
			this.setState({ showRecaptch: true });
		}

		// Always update component (I don't feel like digging into this rabbit hole...)
		return true;
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	// ===================================
	//  INPUT CHANGES
	// ===================================
	setRecaptchaLoaded = () => {
		// Recaptcha is ready to be shown
		this.setState({
			recaptchaLoaded: true
		});
	};

	// ===================================
	//  SUBMIT
	// ===================================
	handleSubmit = () => {
		if (this.props.maxLoginsReached && !this.state.recaptchaLoaded) {
			return;
		}

		this.props
			.reviewerLogin(
				this.state.data.email,
				this.state.data.password,
				this.state.data.recaptcha
			)
			.catch(() => {
				// Reset recaptcha
				if (this.captcha && this.state.recaptchaLoaded) {
					this.captcha.reset();
					this.setState({
						data: {
							...this.state.data,
							recaptcha: null
						}
					});
				}
			});
	};

	render() {
		const { showRecaptch, data } = this.state;
		const { translations } = this.props;

		// The recaptcha is loading if it's going to be shown and it's still being loaded
		const recaptchaIsLoading = showRecaptch && !this.state.recaptchaLoaded;

		return (
			<div className="centered-form">
				<div className="form-title">
					{translations.sections.reviewer_login_form.login_title}
				</div>
				<div className="form-content">
					{this.props.loginTokenLoading ? (
						<GeneralLoader />
					) : (
						<React.Fragment>
							<div className="centered-form-field">
								<label htmlFor="email">
									{translations.sections.reviewer_login_form.email_label}:
								</label>

								{this.props.errors.email && (
									<ErrorWrap animate={1}>{this.props.errors.email}</ErrorWrap>
								)}
								<input
									type="text"
									name="email"
									id="email"
									value={data.email}
									placeholder="name@domain.com"
									onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
									onChange={e => this.setState(handleInputChange(e, this.state))}
									disabled={recaptchaIsLoading}
								/>
							</div>

							<div className="centered-form-field">
								<label htmlFor="password">
									{translations.sections.reviewer_login_form.password_label}:
								</label>

								{this.props.errors.password && (
									<ErrorWrap animate={1}>{this.props.errors.password}</ErrorWrap>
								)}
								<input
									type="password"
									name="password"
									id="password"
									value={data.password}
									placeholder="password"
									onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
									onChange={e => this.setState(handleInputChange(e, this.state))}
									disabled={recaptchaIsLoading}
								/>
							</div>

							{showRecaptch && (
								<Reaptcha
									ref={e => (this.captcha = e)}
									sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
									onVerify={value =>
										recaptchChanged(value, this.state).then(res =>
											this.setState(res)
										)
									}
									onLoad={() => this.setRecaptchaLoaded()}
								/>
							)}

							<div className="btn_container">
								{this.props.errors.general && (
									<ErrorWrap animate={1}>{this.props.errors.general}</ErrorWrap>
								)}
								<Button
									text={translations.sections.reviewer_login_form.login_button}
									clickHandler={this.handleSubmit}
									{...this.props}
									isDisabled={recaptchaIsLoading}
								/>
							</div>
						</React.Fragment>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		errors: state.user.errors,
		isLoading: state.user.isLoading,
		loginTokenLoading: state.user.loginTokenLoading,
		maxLoginsReached: !!state.user.maxLoginsReached.reviewer
			? state.user.maxLoginsReached.reviewer
			: false
	};
};

export default connect(
	mapStateToProps,
	{ getReviewerLoginToken, reviewerLogin, clearErrors }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/reviewer/login/LoginForm.js